import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["icon"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { initUFO } from '@atlassian/mpac-telemetry';
import { Option } from 'funfix-core';
import AnalyticsClient from '../analytics/Client';
import { makeContext, makeUrlContextIcon } from '../records/Context';
import { doInitializeAnalytics } from './Analytics';
import { doRetrieveFeatureFlags, doRetrieveFrontendBootstrap, doRetrieveHostConfig, doRetrieveHostInfo } from './Configuration';
import { changeContext, doRetrieveDefaultContext } from './Contexts';
import { doRetrieveHostPricing } from './HostPricing';
import { doRetrieveScopesLookup } from './Scopes';
import { doRetrieveCurrentUserId } from './Users';
export const doInitializeBaseData = _ref => {
  let {
    bootstrapConfig,
    statsigClientMpac
  } = _ref;
  return dispatch => {
    attemptBaseDataInitialization(dispatch)({
      bootstrapConfig,
      statsigClientMpac
    });
    dispatch(doRetrieveScopesLookup({
      bootstrapConfig
    }));
    dispatch(doRetrieveHostPricing());
  };
};
const attemptBaseDataInitialization = dispatch => async _ref2 => {
  let {
    bootstrapConfig,
    statsigClientMpac
  } = _ref2;
  try {
    // init statsig
    const {
      statsig: statsigConfig
    } = bootstrapConfig;

    // LOCAL DEV
    if (process.env.NODE_ENV === 'development' && statsigConfig) {
      await statsigClientMpac.initializeStatsigClient({
        clientKey: statsigConfig.clientKey,
        environment: statsigConfig.environment,
        targetApp: statsigConfig.targetApp,
        tenantId: 'local-tenant-id',
        atlassianAccountId: 'local-acc-id'
      }, {
        targetApp: statsigConfig.targetApp,
        tenantId: 'local-tenant-id',
        atlassianAccountId: 'local-acc-id',
        cloudId: 'local-cloud-id'
      }, 'PRODUCT');
    }
    // INSIDE JIRA / CONNIE / OTHERS
    else {
      await statsigClientMpac.initWithStatsigGlobalInstance('PRODUCT');
    }
    const currentUserIdPromise = dispatch(doRetrieveCurrentUserId());
    const hostInfo = await dispatch(doRetrieveHostInfo());
    const hostConfig = await dispatch(doRetrieveHostConfig(hostInfo));
    const frontendBootstrap = await dispatch(doRetrieveFrontendBootstrap());
    AnalyticsClient.init(bootstrapConfig, hostConfig, hostInfo);
    const analyticsInstance = AnalyticsClient.get();
    initUFO(analyticsInstance, statsigClientMpac.enableReactUFOEmcee, {
      product: 'emcee'
    });
    const currentUserId = await currentUserIdPromise;
    dispatch(doRetrieveFeatureFlags({
      bootstrapConfig,
      hostConfig,
      hostInfo,
      currentUserId: frontendBootstrap.launchDarklyUserKey
    }));
    await attemptAnalyticsInitialization(dispatch)({
      bootstrapConfig,
      hostConfig,
      hostInfo,
      currentUserId
    });
    if (hostInfo.supports.context) {
      dispatch(doRetrieveDefaultContext());
    } else if (hostInfo.globalContext) {
      const _hostInfo$globalConte = hostInfo.globalContext,
        {
          icon: hostInfoIcon
        } = _hostInfo$globalConte,
        context = _objectWithoutProperties(_hostInfo$globalConte, _excluded);
      const icon = hostConfig.globalContext.flatMap(gc => gc.icon).orElse(Option.of(hostInfoIcon).map(makeUrlContextIcon));
      dispatch(changeContext(makeContext(_objectSpread(_objectSpread({}, context), {}, {
        icon
      }))));
    }
  } catch (error) {
    console.error(error);
  }
};
const attemptAnalyticsInitialization = dispatch => async _ref3 => {
  let {
    bootstrapConfig,
    hostConfig,
    hostInfo,
    currentUserId
  } = _ref3;
  try {
    await dispatch(dispatch(doInitializeAnalytics({
      bootstrapConfig,
      hostConfig,
      hostInfo,
      currentUserId
    })));
  } catch (error) {
    console.error(error);
  }
};